import * as yup from 'yup'

const zipCodeSchema = yup
	.string()
	.test('is-digits-only', 'Must be a number with exactly 5 digits', value => {
		if (!value) return true
		return /^\d{5}$/.test(value)
	})

export default zipCodeSchema
